import { ImpactPartner } from "../models/ImpactPartner";
import { Order } from "../models/Order";
import { ServiceBase, PagedResult } from "./ServiceBase";

export default class OrderService extends ServiceBase {
    public static async orderSearch(impactPartnerId: any, partnerId: any, orderNumber: string, startDate: Date, endDate: Date, cartName: string, pageIndex: number, pageSize: number) {
        let response = await this.requestJson<PagedResult<Order>>({
            url: `/api/orders/search`,
            method: "POST",
            data: {
                impactPartnerId, partnerId, orderNumber, startDate, endDate, cartName, pageIndex, pageSize
            }
        });

        return response;
    }

    public static async reorder(impactPartnerId: any, userId: string, orderPartner: ImpactPartner, orderId) {
        let response = await this.requestClietAuthJson<any>(orderPartner, {
            url: `/api/orders/reorder`,
            method: "POST",
            data: {
                impactPartnerId, userId, orderPartnerId: orderPartner.Id, orderId: orderId
            }
        });

        return response;
    }

    public static async checkOrderProducts(orderPartner: ImpactPartner, orderId: string) {
        let response = await this.requestClietAuthJson<any>(orderPartner, {
            url: `/api/orders/checkProducts?orderId=${orderId}`,
            method: "GET"
        });

        return response;
    }
}